import type { ContentNode, DataTypeLocator } from '@helo/cms'
import {
  ContentNodeUtils,
  ManualContentHelpers,
  RuntimeOperations,
} from '@helo/cms'

import { RuntimeOperationBaseContext } from '../../../../../../packages/cms/dist/esm/StateOperations/runtime-processing.parts'

/**
 * Resolves the primary **entity display string** for the current detail screen
 * (e.g. purchase order id, item id, shipment id, container id) — the same
 * formatted scalar as the page heading/back link, for use in `document.title`.
 */
export const deriveDetailEntityDisplayString = (
  queryId: string,
  selector: DataTypeLocator | undefined,
  query: (id: string) => unknown,
): string | null => {
  try {
    const processed = RuntimeOperations.processValue({
      query,
    } as RuntimeOperationBaseContext)(
      ManualContentHelpers.setState(
        ManualContentHelpers.createContentNodeReference(
          queryId,
          selector ?? [],
        ),
        { linkUrl: false },
      ),
    ) as ContentNode | null

    if (!processed || typeof processed !== 'object' || !('data' in processed)) {
      return null
    }

    const raw = ContentNodeUtils.asText()(processed)
    const trimmed = raw?.trim()
    if (!trimmed || trimmed === '-' || trimmed === 'Multiple') {
      return null
    }
    return trimmed
  } catch {
    return null
  }
}
